
import * as actions from './actions'
import reducer from './reducer'
import * as selectors from './selectors'

import { ReduxBundle } from '../lib'

import { LayoutState } from './typings'


type LayoutActions = typeof actions
type LayoutSelectors = typeof selectors


export type LayoutBundle = ReduxBundle<LayoutState, LayoutActions, LayoutSelectors>


export { actions, reducer, selectors }


export const makeBundle = (): LayoutBundle => ({
  actions,
  reducer,
  selectors
})

export default { actions, reducer, selectors } as LayoutBundle
